import React from 'react';
import { motion } from 'framer-motion';
import { getVisionPassportIndicator } from '../../utils/documentVision';

export default function VisionPassportIndicator({ doc }) {
  const indicator = getVisionPassportIndicator(doc);

  return (
    <motion.span
      className="vision-passport-indicator"
      style={{ color: indicator.color }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ type: 'spring', stiffness: 90, damping: 22 }}
    >
      {indicator.label}
    </motion.span>
  );
}
